﻿import React from "react";

interface Props {
    text: string,
    top: number,
    left: number,
    height: number,
    width: number,
    titleTextSizeEm?: number
}


export function ValueGroupHeaderComponent(props: Props): React.JSX.Element {

    return (
        <>
            <React.StrictMode>
                <div
                    className="midi_SiteObservations_value_box_outer"
                    style={{
                        top: `${props.top}%`,
                        left: `${props.left}%`,
                        height: `${props.height}%`,
                        width: `${props.width}%`,
                        cursor: "auto"
                    }}
                >
                    {/* Header */}
                    <div
                        className="midi_SiteObservations_value_group_header"
                        style={{
                            fontSize: `${props.titleTextSizeEm}em`
                        }}
                    >
                        {props.text}

                    </div>
                </div>
            </React.StrictMode>
        </>
    );
}